import React from 'react';
import { APP_NAME } from '../../design-system/v2';
import './brand-lockup.css';

const PLUS = (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.4" strokeLinecap="round" aria-hidden="true">
    <path d="M12 5v14M5 12h14" />
  </svg>
);

type Props = {
  /** Badge height in px; the wordmark scales from it. */
  height?: number;
  /** Badge only (collapsed rails, mobile); the wordmark stays for screen readers. */
  compact?: boolean;
  busy?: boolean;
  href?: string;
  onClick?: React.MouseEventHandler<HTMLElement>;
  className?: string;
};

/** EnsoMirai++ wordmark + animated ++ badge. Renders a link when `href` is given, otherwise a span. */
export const BrandLockup: React.FC<Props> = ({ height = 30, compact, busy, href, onClick, className }) => {
  const cls = ['ens-brand', compact && 'compact', busy && 'is-busy', className].filter(Boolean).join(' ');
  const style = { '--h': `${height}px` } as React.CSSProperties;
  const body = (
    <>
      <span className="brand-word">EnsoMirai</span>
      <span className="brand-mark" aria-hidden="true">
        <span className="brand-glow" />
        <span className="brand-trace" />
        <span className="brand-logo">{PLUS}{PLUS}</span>
      </span>
    </>
  );
  return href ? (
    <a className={cls} style={style} href={href} onClick={onClick} aria-label={`${APP_NAME} home`}>{body}</a>
  ) : (
    <span className={cls} style={style} role="img" aria-label={APP_NAME} onClick={onClick}>{body}</span>
  );
};

export default BrandLockup;
